import React from "react";
import { Check, Circle } from "lucide-react";

const CORE = [
  ["create_project", "Create your first project"],
  ["connect_pinlayr", "Connect Pinlayr"],
  ["first_pin", "Create your first pin"],
];
const OPTIONAL = [
  ["customize_widget", "Customize your widget"],
  ["invite_team", "Invite your team or reviewers"],
  ["connect_workflow", "Connect your workflow"],
];

function Row({ done, label }) {
  return (
    <div className="flex items-center gap-2.5 py-1.5">
      {done ? <Check className="h-[18px] w-[18px] text-[#16A34A]" /> : <Circle className="h-[18px] w-[18px] text-[#4A5164]" />}
      <span className={`text-[14px] ${done ? "text-[#6E7686] line-through" : "text-[#C4C9D4]"}`}>{label}</span>
    </div>
  );
}

export default function GettingStarted({ checklist }) {
  const c = checklist || {};
  const total = CORE.length + OPTIONAL.length;
  const complete = [...CORE, ...OPTIONAL].filter(([k]) => c[k]).length;
  return (
    <div className="rounded-2xl border border-[#242A38] bg-[#151A24] p-5" data-testid="getting-started">
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#A99BFF]">Get Pinlayr ready</span>
        <span className="text-[13px] font-medium text-[#98A0B0]">{complete} / {total}</span>
      </div>
      <div className="mt-3">{CORE.map(([k, l]) => <Row key={k} done={!!c[k]} label={l} />)}</div>
      <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#565E70]">Optional</p>
      <div className="mt-1">{OPTIONAL.map(([k, l]) => <Row key={k} done={!!c[k]} label={l} />)}</div>
    </div>
  );
}
